/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_SearchInputs */

const en_nav_search = /** @type {(inputs: Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search nav`)
};

const ar_nav_search = /** @type {(inputs: Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البحث في القائمة`)
};

const bn_nav_search = /** @type {(inputs: Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নেভিগেশন মেনু খুঁজুন`)
};

const de_nav_search = /** @type {(inputs: Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation durchsuchen`)
};

const es_nav_search = /** @type {(inputs: Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar en la navegación`)
};

const fr_nav_search = /** @type {(inputs: Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher dans la navigation`)
};

const pt_nav_search = /** @type {(inputs: Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar na navegação`)
};

const zh_nav_search = /** @type {(inputs: Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索导航`)
};

const tr_nav_search = /** @type {(inputs: Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arama navigasyonu`)
};

const ru_nav_search = /** @type {(inputs: Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Навигация по поиску`)
};

const pl_nav_search = /** @type {(inputs: Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nawigacja wyszukiwania`)
};

/**
* | output |
* | --- |
* | "Search nav" |
*
* @param {Nav_SearchInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const nav_search = /** @type {((inputs?: Nav_SearchInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_SearchInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_nav_search(inputs)
	if (locale === "bn") return bn_nav_search(inputs)
	if (locale === "de") return de_nav_search(inputs)
	if (locale === "es") return es_nav_search(inputs)
	if (locale === "fr") return fr_nav_search(inputs)
	if (locale === "pt") return pt_nav_search(inputs)
	if (locale === "zh") return zh_nav_search(inputs)
	if (locale === "tr") return tr_nav_search(inputs)
	if (locale === "ru") return ru_nav_search(inputs)
	if (locale === "pl") return pl_nav_search(inputs)
	return en_nav_search(inputs)
});